import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
  Stack,
} from "@mui/material";

const formatPlainNumber = (val) =>
  Number(val || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const ReceiptDetailsTab = ({ receipt }) => {
  const { header } = receipt;

  return (
    <Grid container spacing={3}>
      {/* LEFT COLUMN: Customer & Company Info */}
      <Grid item xs={12} md={5}>
        <Stack spacing={3}>
          <Card
            elevation={0}
            sx={{ border: "1px solid", borderColor: "divider" }}
          >
            <CardContent>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                Customer Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Business Name
              </Typography>
              <Typography variant="body1" fontWeight="500" gutterBottom>
                {receipt.customerBusinessName || "N/A"}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                gutterBottom
                sx={{ mt: 2 }}
              >
                Contact Email
              </Typography>
              <Typography variant="body1" fontWeight="500">
                {receipt.customerEmail || "N/A"}
              </Typography>
            </CardContent>
          </Card>

          <Card
            elevation={0}
            sx={{ border: "1px solid", borderColor: "divider" }}
          >
            <CardContent>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                Issued By (Company Info)
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="subtitle2" fontWeight="bold">
                {header?.companySnapshot?.companyName || "N/A"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                PIN: {header?.companySnapshot?.taxId || "N/A"}
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                {header?.companySnapshot?.address}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {header?.companySnapshot?.phone} |{" "}
                {header?.companySnapshot?.email}
              </Typography>
            </CardContent>
          </Card>
        </Stack>
      </Grid>

      {/* RIGHT COLUMN: Transaction Summary */}
      <Grid item xs={12} md={7}>
        <Card
          elevation={0}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.default",
            height: "100%",
          }}
        >
          <CardContent>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Transaction Overview
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="body2" color="text.secondary">
                Receipt Number
              </Typography>
              <Typography variant="body2" fontWeight="bold" color="info.main">
                {receipt.transactionNumber}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="body2" color="text.secondary">
                Linked Invoice
              </Typography>
              <Typography
                variant="body2"
                fontWeight="500"
                sx={{ fontFamily: "monospace" }}
              >
                {receipt.invoiceNumber || "Unallocated"}
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography variant="body2" color="text.secondary">
                Date Received
              </Typography>
              <Typography variant="body2" fontWeight="500">
                {new Date(receipt.receiptDateTime).toLocaleString()}
              </Typography>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box
              display="flex"
              justifyContent="space-between"
              mb={1}
              alignItems="center"
            >
              <Typography variant="h6" fontWeight="bold">
                Amount Received
              </Typography>
              <Typography variant="h5" fontWeight="bold" color="success.main">
                {formatPlainNumber(receipt.amountPaid)}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ReceiptDetailsTab;
